import { DependencyList, useEffect, useRef } from "react";

// useDidMountEffect hook invoked immediately after updating occurs. This hook is not called for the initial render.
export const useDidMountEffect = (func: () => void, deps: DependencyList | undefined) => {
  const didMount = useRef(false);

  useEffect(() => {
    if (didMount.current) func();
    else didMount.current = true;
  }, deps);
};
